<div class="container">
  <div class="body">
    <img src="assets/already-paid.svg" alt="">
    <div class="text">
      <h3>Essa mesa já foi paga</h3>
      <p>Mas você ainda pode ver os comprovantes</p>
    </div>
  </div>
  <div class="buttons">
    <yoo-button
      primary
      large
      emphasis
      [block]="true"
    >
      <span>Ler QR Code novamente</span>
    </yoo-button>
    <yoo-button
      neutral
      large
      plain
      iconLeft="receipt"
      iconRight="arrow-right"
      [block]="true"
    >
      <span>Ver comprovantes</span>
    </yoo-button>
</div>